import { render, staticRenderFns } from "./ShoppingModal.vue?vue&type=template&id=91361ed6&scoped=true"
import script from "./ShoppingModal.vue?vue&type=script&lang=js"
export * from "./ShoppingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91361ed6",
  null
  
)

export default component.exports